import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { getSubTasks } from "../../actions/userActions/subTaskAction";
import Loader from "../subComponents/Loader";
import Search from "../subComponents/search/Search";
import AddButton from "../subComponents/buttons/AddButton";
import { IconButton,Tooltip } from "@mui/material";
import Pagination from '../paginatioin/pagination';
import EditButton from "../subComponents/buttons/EditButton";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { SIZE_OF_PAGE } from "../../actions/types";
import DynamicTable from "../reuse_components/DynamicTable";
import CustomButton from "../subComponents/buttons/CustomButton";
import CustomPagination from "../subComponents/pagination/CustomPagination";
import SearchInput from "../subComponents/search/SearchInput";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import Heading6Regular from "../designSystem/Heading6Regular";
import thIcon from "../../assets/images/thIcon.svg";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import AddSubTasks from "./AddSubTasks";
import ItemsPerPageSelector from "../subComponents/pagination/ItemsPerPageSelector";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import { t } from "../../locales/translate";

function SubTasks() {
 const [currentPage, setCurrentPage] = useState(1)
  const [previousQuery, setPreviousQuery] = useState("");

  const dispatch = useDispatch();
  const history = useHistory();

  const subTasks = useSelector((state) => state.sub_tasks_reducer.subTasks);
  const subTasksData = subTasks && subTasks.result;
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [SubtaskData, setSubtaskData] = useState([]);
  const totalItems = subTasks?.totalCount  || 0;
  const totalPages = subTasks?.totalPages || 0;
  const permissions = JSON.parse(localStorage.getItem("permissionsList"));
  const [query, setQuery] = useState("");
  const firstPage = 1;
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const isLoading = useSelector((state) => state.sub_tasks_reducer.isSubTaskLoading);
  useEffect(() => {
    const pageNumber = currentPage;
  
      if (query !== previousQuery) {
        setCurrentPage(1);
      }
      dispatch(getSubTasks(pageNumber, itemsPerPage, query));
      setPreviousQuery(query);
  
    }, [currentPage, query]);
  
  
  const handleEditSubTask = (row) => {
    setEditData(row);
    setShowModal(true);
  };
  useEffect(() => {
    const SubtasksData = subTasksData?.map((subTasks) => ({
      ...subTasks,
      status: (
        <span className={subTasks.active ? "status-badge-active" : "status-badge-inactive"}>
          {subTasks.active ? "Active" : "Inactive"}
        </span>
      ),
    }));
    setSubtaskData(SubtasksData);
  }, [subTasks]);
 
 
  const columns = [
    { label: `${t("name")}`, accessor: "name" },
    { label: `${t("description")}`, accessor: "description" },
    {
      label: `${t("status")}`,
      accessor: "status",
      render: (rowData) => <AddSubTasks active={rowData.active} />,
    },
  ];
  const actions = [  
    {
        label: 'Edit SubTask',
        icon: <EditOutlinedIcon sx={{ color: '#0438B4' }}/>,
        permission: 'CanUpdateSubTask',
        handler:handleEditSubTask,
    },
];
const handleItemsPerPageChange = (value) => {
  const pageNumber = firstPage;
  dispatch(getSubTasks(pageNumber, value, query));
  setItemsPerPage(value);
  setCurrentPage(1);
};
const handleSaveData = async () => {
  dispatch(getSubTasks(currentPage, itemsPerPage, query));
  setShowModal(false);
};
const handleAddClick = () => {
  setEditData(null);
  setShowModal(true);
};
const handleCloseModal = () => {
  setShowModal(false);
};
const handleSearchChange = (e) => {
  setQuery(e.target.value);
  setCurrentPage(1);
};
  return (
    <>
    <div>
      <LoadingOverlay isVisible={isLoading} />
    <div className="main-container">
             <div className="content-wrapper">
                <div className="pagination">
                    <SearchInput
                        placeholder="Search"
                        onChange={handleSearchChange}
                        value ={query}
             />
                 <div className="flex-align-center">
                 <div className="items-per-page-container">
            <ItemsPerPageSelector
               value={itemsPerPage}
                 onChange={handleItemsPerPageChange}
              />
            </div>
                       <CustomPagination
                        currentPage={currentPage}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        totalPages={totalPages}
                        onPageChange={(page) => setCurrentPage(page)} 
                      />
                     {permissions && permissions.includes("CanAddSubTask") && (
                            <CustomButton text={t("addNew")} onClick={handleAddClick} />
                        )}
                    </div>
                </div>
              
            </div>
            <DynamicTable
                    data={ SubtaskData}
                    columns={columns}
                    permissions={permissions}
                    actions={actions}
                    thIcon={thIcon}
                    showPagination={totalItems > 0}
                    currentPage={currentPage}
                    totalItems={totalItems}
                    itemsPerPage={itemsPerPage}
                    totalPages={totalPages}
                    onPageChange={(page) => setCurrentPage(page)}
                    onItemsPerPageChange={handleItemsPerPageChange}
                />
            {showModal && (
        <AddSubTasks
          onClose={handleCloseModal}
          editData={editData}
          onSave={handleSaveData}
        />
      )}
        </div>
        </div>
    </>
  );
}

export default SubTasks;
